import React from 'react';
import { Hero } from './components/Hero';
export function App() {
  return <div className="min-h-screen bg-[#09090b] text-white font-mono selection:bg-[#ccff00] selection:text-black" data-id="element-0">
      <Hero data-id="element-1" />
    </div>;
}